import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { IBaseItem } from "../types";
import { SizeGuideServices } from "../../../services";

const ColumnSelectSizeGuide = (
    {
        placeholder
        , value
        , onChange
        , ByCode = false
    }: any) => {

    const [options, setOptions] = useState<any[]>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const onSelectChange = (e: any) => {

        if (onChange) onChange(e.value);
    }

    useEffect(() => {
        (async () => {

            if (ByCode) {
                try {

                    setIsLoading(true);

                    const getResponse = await SizeGuideServices.GetSizesGuidesRelatedCode();

                    if (getResponse.Status === 200) {
                        if (getResponse.Content.length) {

                            const optionsResponse = getResponse.Content.map((element: IBaseItem) => {
                                return {
                                    value: element.Id.toString(),
                                    name: element.Name
                                };
                            });

                            setOptions(optionsResponse);
                        }
                        else {
                            setOptions([]);
                        }
                    }
                    else {
                        setOptions([]);
                    }

                    setIsLoading(false);

                } catch (eByCode) {
                    console.log('ColumnSelectSizeGuide ERROR', eByCode);

                    setIsLoading(false);
                }


            }
            else {

                try {

                    setIsLoading(true);

                    const getResponse = await SizeGuideServices.GetSizesGuides();

                    if (getResponse.Status === 200) {
                        if (getResponse.Content.length) {
                            const optionsResponse = getResponse.Content.map((element: IBaseItem) => {
                                return {
                                    value: element.Id.toString(),
                                    name: element.Name
                                };
                            });

                            setOptions(optionsResponse);
                        }
                        else {
                            setOptions([]);
                        }
                    }
                    else {
                        setOptions([]);
                    }

                    setIsLoading(false);

                } catch (eByName) {
                    console.log('ColumnSelectSizeGuide ERROR', eByName);

                    setIsLoading(false);
                }
            }

        })();

    }, []);

    return (
        <div className="card flex justify-content-center">
            {(!(isLoading)) && (<Dropdown
                value={((options && options.length) ? value : null)}
                onChange={(e) => onSelectChange(e)}
                options={options}
                optionLabel="name"
                placeholder={placeholder}
                className="w-full md:w-14rem"
                style={{minWidth: "100%"}}
            />)
            }
        </div>
    );
};

export default ColumnSelectSizeGuide;
